import InvoiceSales from "@/views/Income/InvoiceSales.vue";
import SaleProducts from "@/views/Income/SaleProducts.vue";
import Prepaid from "@/views/Income/Prepaid.vue";
import ViewInvoice from "@/components/Income/ViewInvoice.vue";
import ViewNote from "@/components/Income/ViewNote.vue";
import DownloadInvoice from "@/components/Income/DownloadInvoice.vue";
import DownloadNote from "@/components/Income/DownloadNote.vue";
import DownloadInvoicesBatch from "@/components/Income/DownloadInvoicesBatch.vue";
import Invoice from "@/views/Income/Invoice.vue";
import OrderSale from "@/views/Income/OrderSale.vue";
import CreditNotes from "@/views/Income/CreditNotes.vue";
import DebitNotes from "@/views/Income/DebitNotes.vue";
import Quote from "@/views/Income/Quote.vue";
import Discount from "@/views/Income/Discount.vue";
import employeeCredit from "@/views/Income/employeeCredit.vue";
const invoiceROutes= {
    path: "/invoice",
    name: "Invoice",
    component: Invoice,
    meta: {
      libre: true
    },
    children: [
      {
        path: "sales",
        name: "InvoiceSales",
        component: InvoiceSales,
        meta: {
          code: "ING-02" // Cambiado de IVENTORY: true a un código específico
        },
      },
      {
        path: "product_sales",
        name: "productSales",
        component: SaleProducts,
        meta: {
          code: "ING-08" // Cambiado de IVENTORY: true a un código específico
        },
      },
      {
        path: "order_sales",
        name: "OrderSale",
        component: OrderSale,
        meta: {
          code: "ING-03" // Cambiado de IVENTORY: true a un código específico
        },
      },
      {
        path: "prepaid",
        name: "Prepaid",
        component: Prepaid,
        meta: {
          code: "ING-07" // Cambiado de IVENTORY: true a un código específico
        },
      },
      {
        path: "discount",
        name: "Discount",
        component: Discount,
        meta: {
          code: "ING-06" // Cambiado de IVENTORY: true a un código específico
        },
      },
      {
        path: "quote",
        name: "Quote",
        component: Quote,
        meta: {
          code: "ING-01" // Cambiado de IVENTORY: true a un código específico
        },
      }, 
      {
        path: "credit_notes",
        name: "CreditNotes",
        component: CreditNotes,
        meta: {
          code: "ING-04" // Cambiado de IVENTORY: true a un código específico
        },
      },
      {
        path: "debit_notes_sale",
        name: "DebitNotesSale",
        component: DebitNotes,
        meta: {
          code: "ING-04" // Comparte permiso con notas de crédito de venta
        },
      },
      {
        path: "view_invoice/:id?",
        name: "ViewInvoice",
        component: ViewInvoice,
        meta: {
          libre: true
        },
      },
      {
        path: "view_note/:id?",
        name: "ViewNote",
        component: ViewNote,
        meta: {
          libre: true
        },
      },
      {
        path: "download_invoice/:id?",
        name: "DownloadInvoice",
        component: DownloadInvoice,
        meta: {
          libre: true
        },
      },
      {
        path: "download_invoices",
        name: "DownloadInvoicesBatch",
        component: DownloadInvoicesBatch,
        meta: {
          code: "ING-02"
        },
      },
      {
        path: "download_note/:id?",
        name: "DownloadNote",
        component: DownloadNote,
        meta: {
          libre: true
        },
      },
      {
        path: "employeeCredit",
        name: "employeeCredit",
        component: employeeCredit,
        meta: {
          code: "ING-09" // Cambiado de IVENTORY: true a un código específico
        },
      },
    ],
  }

export default invoiceROutes